import script from "./MsDynamicPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./MsDynamicPopup.vue?vue&type=script&setup=true&lang=js"

import "./MsDynamicPopup.vue?vue&type=style&index=0&id=7d2d3fdc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d2d3fdc"]])

export default __exports__